










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableView } from '@/ts/interfaces/TableConfigTypes';

@Component({})
export default class AddViewModal extends Vue {
    @Prop() public value: any;
    @Prop() public viewOptionList: TableView[];

    public viewName: string = '';

    get dialog() {
        return this.value;
    }

    set dialog(value) {
        this.$emit('input', value);
    }

    get viewNameExists(): boolean {
        return this.viewOptionList.some((view) => (view && this.viewName) && (view.name.toLowerCase() === this.viewName.toLowerCase()));
    }

    get errorMessage() {
        return;
    }

    public resetName() {
        this.viewName = '';
    }

    public onSaveView() {
        this.$emit('onSubmitNewView', this.viewName);
        this.viewName = '';
    }
}
